import { render, staticRenderFns } from "./KnAccessDenied.vue?vue&type=template&id=6e28bd74&"
import script from "./KnAccessDenied.vue?vue&type=script&lang=js&"
export * from "./KnAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports